
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@/context/UserContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useUser();
  
  if (isLoading) {
    return <div>Loading...</div>;
  }
  
  // For public routes, we allow access regardless of authentication status
  return <>{children}</>;
};

export default PublicRoute;
